import { LogLevel, Configuration, PopupRequest, EndSessionRequest } from '@azure/msal-browser';

// Development mode flag - set to true to bypass Azure AD authentication
export const DEV_MODE: boolean = !import.meta.env.VITE_AZURE_CLIENT_ID;

// Azure AD configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || 'cff246b3-7ce0-41fb-906c-484dde6116ed',
    authority: import.meta.env.VITE_AZURE_AUTHORITY || 'https://login.microsoftonline.com/9d479da0-91f6-4c99-8877-b3ebdab675f3',
    redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ['User.Read'],
};

// API access scopes
// Using custom API scope for LACE Tool API
export const apiRequest: PopupRequest = {
  scopes: [`api://${import.meta.env.VITE_AZURE_CLIENT_ID || 'cff246b3-7ce0-41fb-906c-484dde6116ed'}/access_as_user`],
};

// Temporary fallback for testing - using Microsoft Graph scope
export const apiRequestFallback: PopupRequest = {
  scopes: ['User.Read'],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
